// extracted by mini-css-extract-plugin
export default {"secret":"secret_secret__FoJ8Y","logo":"secret_logo__XZ4Ai"};